/* eslint-disable no-param-reassign */
import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree, setField } from '../helpers/savedSearches';

export const deleteGroup = createAsyncThunk(
  'savedSearches/deleteGroup',
  async (
    { path, isShared, showDialog = true },
    {
      extra: {
        sdk, Logger, Toast, showDialogAsync, localization: l10n,
      },
      getState,
    },
  ) => {
    try {
      const groupName = path.split(NEW_PATH_DELIMITER).pop();
      if (showDialog) {
        try {
          const { all } = getState().savedSearches;
          const searchesInGroup = all.filter((ss) => {
            if (isShared) {
              return ss.teamId && ss.path && ss.path.startsWith(path + NEW_PATH_DELIMITER);
            }
            return !ss.teamId && ss.path && ss.path.startsWith(path + NEW_PATH_DELIMITER);
          });

          const { promise } = showDialogAsync({
            title: l10n.TAGSTREE.titleRemoveSavedSearchGroup,
            text: l10n.TAGSTREE.textYouAreAboutRemoveSavedSearchGroup(groupName, searchesInGroup.length),
            textBtnOk: l10n.DIALOGS.btnDelete,
          });

          await promise;
        } catch (error) {
        /** User cancelled the dialog, we treat it as non-error case, so just return */
          return null;
        }
      }

      await sdk.savedSearches.deleteGroup(path, isShared);

      Toast(l10n.TAGSTREE.textHasBeenRemovedGroup(groupName), { type: 'success' });

      return { userId: getState().user._id };
    } catch (error) {
      Logger.error(new Error('Can not delete saved search group'), { error }, [
        'DeleteSavedSearchGroupFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error deleting saved search group', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    deleteGroup.pending,
    (state, { meta: { arg: { path } } }) => {
      state.tree = setField(state.tree, path, 'isBusy', true);
    },
  ).addCase(
    deleteGroup.fulfilled,
    (state, { payload, meta: { arg: { path, isShared } } }) => {
      if (!payload) {
        /** if cancelled */
        state.tree = setField(state.tree, path, 'isBusy', false);
        return;
      }
      const { userId } = payload;
      const start = path + NEW_PATH_DELIMITER;
      state.all = state.all.map((ss) => {
        if (ss.path && ss.path.startsWith(start)) {
          if (isShared && ss.teamId) return null;
          if (!isShared && !ss.teamId) return null;
        }
        return ss;
      }).filter(Boolean);
      state.tree = makeTree(state.all, userId);
    },
  ).addCase(
    deleteGroup.rejected,
    (state, { meta: { arg: { path } }, error }) => {
      state.error = error;
      state.tree = setField(state.tree, path, 'isBusy', false);
    },
  );
};
